/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useRef, useState} from 'react';
import './GameIntro.scss';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {currentGameInfoQuery} from '../recoil/selectors';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlay, faTimes} from '@fortawesome/free-solid-svg-icons';
import {currentScreenState} from '../recoil/atoms';
import {PLAYLIST_SCREEN} from '../recoil/state';
import {sign} from '../Api';
import {getVideoPath} from '../Helper';

function GameIntro() {
  const currentGame = useRecoilValue(currentGameInfoQuery);
  const setCurrentScreenID = useSetRecoilState(currentScreenState);
  const [isPlaying, setIsPlaying] = useState(false);

  const videoRef = useRef();

  const handlePlay = (e) => {
    e.preventDefault();
    videoRef.current.controls = true;
    videoRef.current.src = sign(getVideoPath(currentGame.video, /*currentGame.site, currentGame.shootId*/ 'bangbrosclips', 'bbc17624', '1080p'));
    videoRef.current.play();
    setIsPlaying(true);
  };

  const handlePlayTrailer = (e) => {
    e.preventDefault();
    videoRef.current.controls = true;
    videoRef.current.src = currentGame.trailer;
    videoRef.current.play();
    setIsPlaying(true);
  };

  const handleEndOfVideo = (e) => {
    e.preventDefault();
    videoRef.current.controls = false;
    videoRef.current.load();
    setIsPlaying(false);
  };

  const handleStartGame = (e) => {
    e.preventDefault();
    setCurrentScreenID(PLAYLIST_SCREEN);
  };

  return (

      <div className="interactive-intro">

        {!isPlaying &&
        <div className="interactive-intro__body">
          <div className="interactive-intro__background"
               style={{backgroundImage: `url(${currentGame.poster})`}}/>
          <div className="interactive-intro__details">
            <div className="interactive-intro__details__text">
              <h4 className="mobile-only"><b>{currentGame.title}</b></h4>
              <p className="mobile-only">{currentGame.description}</p>
              <p className="desktop-only">
                <b>{currentGame.title}</b><br/>{currentGame.description.substring(0, 100)}...</p>
            </div>
            <div className="interactive-intro__details__button-group mx-0">
              {currentGame.trailer && <a href="#" onClick={handlePlayTrailer}
                 className="button button-secondary col-6 d-flex align-items-center justify-content-center">
                <FontAwesomeIcon className="mr-2 fa-2x" icon={faPlay}/>
                <span className="mb-0 text-left">View<br/>Trailer</span>
              </a> }
              {currentGame.video && <a href="#" onClick={handlePlay}
                 className="button button-danger col-6 d-flex align-items-center justify-content-center">
                <FontAwesomeIcon className="mr-2 fa-2x" icon={faPlay}/>
                <span className="mb-0 text-left">View<br/>Movie</span>
              </a> }
              {currentGame.fragments > 1 && <a href="#" onClick={handleStartGame}
                 className="button button-warning col-6 d-flex align-items-center justify-content-center">
                <FontAwesomeIcon className="mr-2 fa-2x" icon={faPlay}/>
                <span className="mb-0 text-left">Start<br/>Game</span>
              </a>}
            </div>
          </div>
        </div>
        }

        <div className="interactive-intro__trailer"
             style={{"display": isPlaying ? 'block' : 'none'}}>
          <video
              playsInline
              ref={videoRef}
              autoPlay={false}
              width="100%"
              height="100%"
              controlsList={'nodownload nofullscreen'}
              disablePictureInPicture={true}
              onEnded={handleEndOfVideo}
          >
            <source src={currentGame.trailer} type="video/mp4"/>
          </video>

        </div>
        <div className="interactive-intro__trailer__exit_button link-button" onClick={handleEndOfVideo}
             style={{"display": isPlaying ? 'block' : 'none'}}>
          <FontAwesomeIcon className="mr-2 fa-2x" icon={faTimes}/>
        </div>
      </div>
  );
}

export default GameIntro;
